// extracted by mini-css-extract-plugin
module.exports = {"button":"ReadMoreButton__button__7d31351a","arrow":"ReadMoreButton__arrow__7d31351a","expanded":"ReadMoreButton__expanded__7d31351a"};